export default "__VITE_ASSET__BL$I8DgR__"